'use client';

import { Pagination } from '@gds/Pagination/Pagination';
import { useRouter } from 'next/navigation';

import { PaginationProps } from './Pagination.entity';

export const FavouritesPagination = ({ currentPage, strings, totalPages }: PaginationProps) => {
  const router = useRouter();

  const handleClick = (pageNumber: number) => {
    const pageQueryParam = pageNumber === 1 ? `` : `page=${pageNumber}`;
    const newUrl = `/favourites/${pageQueryParam}`;

    router.push(newUrl);
  };

  return (
    <Pagination
      currentPage={currentPage}
      data-test-id="favourites-pagination"
      locale={strings}
      onClick={handleClick}
      totalPages={totalPages}
    />
  );
};
